import { render } from "./BasePage.vue?vue&type=template&id=769139a2&scoped=true&ts=true"
import script from "./BasePage.vue?vue&type=script&lang=ts"
export * from "./BasePage.vue?vue&type=script&lang=ts"

import "./BasePage.vue?vue&type=style&index=0&id=769139a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-769139a2"]])

export default __exports__